export default {
  get_all: { method: "get", url: "api/tipos-instrumentos" },
  show: { method: "get", url: "api/tipos-instrumentos{/id}" },
  store: { method: "post", url: "api/tipos-instrumentos" },
  update: { method: "put", url: "api/tipos-instrumentos{/id}" },
  delete: { method: "delete", url: "api/tipos-instrumentos{/id}" },
};
